export default function PatientRepetitionRateIcon(props) {
	return (
		<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.576884 17.7333C-1.09794 16.0444 1.2827 14.2233 2.53907 12.9564C3.79543 11.6895 5.49943 10.9778 7.2762 10.9778C9.05297 10.9778 10.757 11.6895 12.0133 12.9564C13.2697 14.2233 15.6503 16.0444 13.9755 17.7333C12.3007 19.4222 2.25171 19.4222 0.576884 17.7333ZM7.2762 10.1333C4.50017 10.1333 2.25171 7.866 2.25171 5.06667C2.25171 2.26733 4.50017 0 7.2762 0C10.0522 0 12.3007 2.26733 12.3007 5.06667C12.3007 7.866 10.0522 10.1333 7.2762 10.1333ZM15.6503 13.5111H19V15.2H15.6503V13.5111ZM13.1381 9.28889H19V10.9778H13.1381V9.28889ZM14.8129 5.06667H19V6.75556H14.8129V5.06667Z"
				fill="currentColor"
			/>
		</svg>
	);
}
